export default __webpack_public_path__ + "static/media/patient_add.8582403e.svg";